export const BUTTON_COLOR_HOVER = 'hover:bg-gray-800';
export const BUTTON_COLOR_ACTIVE = 'bg-gray-700';
